<div class="container-fluid">
  <div class="row justify-content-center mt-5">
    <header class="header">
      <h3 class="text-center">Label Print Form</h3>
    </header>
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="labelPrintForm" (ngSubmit)="labelPrint()" (keydown.enter)="$event.preventDefault()">
            <div class="row mb-3">
              <!-- Ticket Number Selector -->
              <div class="col-md-4 mb-3">
                <label for="ticketNo" class="form-label">Ticket Number</label>
                <select formControlName="ticketNo" id="ticketNo" class="form-control" (change)="onTicketSelect($event)" *ngIf="tickets.length > 0">
                  <option value="">Select Ticket</option>
                  <option *ngFor="let ticket of tickets" [value]="ticket.ticketno">{{ ticket.ticketno }}</option>
                </select>
                <div *ngIf="tickets.length === 0">Loading tickets...</div> <!-- Loading message when no tickets -->
              </div>
              
              <!-- <div class="col-md-4 mb-3">
                <label for="ticketNo" class="form-label">Ticket Number</label>
                <select formControlName="ticketNo" id="ticketNo" class="form-control" (change)="onTicketSelect($event)">
                  <option value="">Select Ticket</option>
                  <option *ngFor="let ticket of tickets" [value]="ticket">{{ ticket }}{{ ticket.ticketno }}</option>
                </select>
              </div> -->
              
              <div class="col-md-4 mb-3">
                <label for="RollNo" class="form-label">Enter Roll Number</label>
                <input type="text" id="RollNo" class="form-control" placeholder="Enter Roll Number"
                       formControlName="enteredRollNo" />  
              </div>
              <div class="col-md-4 mb-3">
                <label for="jobName" class="form-label">job Name</label>
                <input type="text" id="jobName" class="form-control" placeholder="Enter jobName"
                       formControlName="jobName" />  
              </div><div class="col-md-4 mb-3">
                <label for="date" class="form-label">date</label>
                <input type="date" id="date" class="form-control" placeholder="date"
                       formControlName="date" />  
              </div>
              <div class="col-md-4 mb-3">
                <label for="width" class="form-label">Enter width</label>
                <input type="text" id="width" class="form-control" placeholder="Enter width"
                       formControlName="width" />  
              </div>
              <div class="col-md-4 mb-3">
                <label for="batch" class="form-label">JTK / Batch</label>
                <input type="text" id="batch" class="form-control" placeholder="JTK / Batch"
                       formControlName="batch" />  
              </div>
              <!-- Number of Rows Input -->
              <div class="col-md-4 mb-3">
                <label for="row" class="form-label">Enter Number of Rows</label>
                <input type="number"  id="row" class="form-control" placeholder="Enter Number of Rows" 
                [value]="rowCount" 
                (input)="onRowNumberChange($event)" />
              </div>

             
              
              
            </div>

            <!-- Table for Dynamic Rows -->
            <div formArrayName="row">
              <div *ngFor="let row of labelPrintForm.get('row')?.controls as FormArray; let i = index" [formGroupName]="i">
                <table class="table table-bordered">
                  <thead>
                    <!-- <tr>
                      <th>Job Name</th>
                      <td><input type="text" formControlName="jobName" class="form-control" placeholder="Job Name" /></td>
                    </tr> -->
                    <!-- <tr>
                      <th>Date</th>
                      <td><input type="date" formControlName="date" class="form-control" placeholder="Date" /></td>
                      <th>Width</th>
                      <td><input type="text" formControlName="width" class="form-control" placeholder="Width" /></td>
                    </tr> -->
                    <tr>
                      <th>Roll Number</th>
                      <td><input type="text" formControlName="rollNo" class="form-control" placeholder="Roll Number" /></td>
                      <th>Net Wet</th>
                      <td><input type="text" formControlName="netwet" class="form-control" placeholder="Net Wet" /></td>
                    </tr>
                    <!-- <tr>
                      <th>JTK / Batch</th>
                      <td><input type="text" formControlName="batch" class="form-control" placeholder="JTK / Batch" /></td>
                    </tr> -->
                  </thead>
                </table>
              </div>
            </div>

            <div class="text-end">
              <button type="submit" class="btn btn-outline-dark">Submit</button>
            </div>
          </form>
        </div><!-- end card-body -->
      </div><!-- end card -->
    </div><!-- end col -->
  </div><!-- end row -->
</div><!-- end container -->
